export class ErrorMessage {
    public static get ApiRequestError(): string {
        return `Неудалось выполнить запрос`;
    }

}